import { iconSize } from "../../tokens";
import { textFieldIconSizeMap } from "../text-field";
import type { SelectSize } from "./types";

/**
 * Combined visual state for the Select trigger.
 * Mirrors TextFieldVisualState — "open" replaces "focused" for Select.
 */
export type SelectVisualState = "default" | "open" | "error" | "disabled";

export function getSelectVisualState({
  disabled,
  isOpen,
  state,
}: {
  disabled: boolean;
  isOpen: boolean;
  state: "default" | "error";
}): SelectVisualState {
  if (disabled) return "disabled";
  if (state === "error") return "error";
  if (isOpen) return "open";
  return "default";
}

/**
 * The chevron's size, as TextField's icons per size: small 20 (desktop web 24),
 * medium 24
 */
export const selectIconSize = {
  sm: textFieldIconSizeMap.sm,
  md: textFieldIconSizeMap.md,
} as const satisfies Record<SelectSize, unknown>;

/** An option's leading icon: 16 at every width, as the selected check */
export const selectOptionIconSize = iconSize.sm;

/**
 * Native: the small 40px trigger takes taps 2px past its top and bottom, to 44.
 * The medium trigger is 48px already.
 */
export const selectTriggerHitSlop = {
  sm: { top: 2, bottom: 2 },
  md: undefined,
} as const satisfies Record<SelectSize, unknown>;

/** Max dropdown height in px — longer option lists scroll. */
export const selectContentMaxHeight = 280;
